/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 19:15:18
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {ExceptionTaskDOI} from "./api/exceptionTaskApi";
import ExceptionTaskService from "./service/exceptionTaskService";
import './exceptionTask.less';

@Component({name: 'exception-task'})
export default class ExceptionTask extends BasicSearchPage<ExceptionTaskService, ExceptionTaskDOI.RowDataI, ExceptionTaskDOI.QueryRowDataParamsI> {
    
    @override
    renderHead(h) {
        return <div></div>
    }
	@override
	loadService () {
		this.service = new ExceptionTaskService(this)
	}
}